export default "__VITE_ASSET__16cc8a3f__"